<template>
    <v-app>
        <v-app-bar app dark color="blue darken-3" v-show="this.$route.name != 'Login'" dense>
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>
                <v-btn plain text to="/"><h2 class="text-capitalize">獣害NAVI</h2></v-btn>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>

        <v-navigation-drawer app temporary v-model="drawer" style="z-index: 2000" class="deep-purple accent-2" height="90%" dark>
            <v-list>
                <v-list-item v-for="item in drawerItems" :key="item.id" link :to="item.to">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item href="/manuals/m001.pdf" target="_blank" rel="noopener noreferrer">
                    <v-list-item-icon>
                        <v-icon>mdi-book-open-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>マニュアル</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-4">
                    <v-btn class="grey darken-2" block to="/logout"><h3>ログアウト</h3></v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<style>
html {
    touch-action: manipulation;
}
.v-application {
    font-family: "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Meiryo", "sans-serif" !important;
}
</style>

<script>
export default {
    name: "App",

    data: () => ({
        drawer: false,
        drawerItems: [
            //{ id: 1, title: "ダッシュボード", icon: "mdi-view-dashboard", to: { name: "Dashboard" } },
            { id: 1, title: "マップ", icon: "mdi-map-marker-radius", to: { name: "SensorMap" } },
            { id: 2, title: "ダッシュボード", icon: "mdi-view-dashboard", to: "/dashboard" },
            { id: 3, title: "画像解析集計", icon: "mdi-align-horizontal-left", to: { name: "Summaries" } },
            //{ id: 4, title: "アカウント設定", icon: "mdi-account-box", to: "/account" },
            //{ id: 4, title: "ログアウト", icon: "mdi-logout", to: "/logout" },
            //{ id: 9, title: "マニュアル", icon: "mdi-book-open-variant", to: "/" },
        ],
    }),
};
</script>
